
import { Component, Watch, Vue } from "vue-property-decorator";
import LocaleSwitcher from "@/components/LocaleSwitcher.vue";
import { Getter } from "vuex-class";
import EnvCompanySelect from "@/components/company/EnvCompanySelect.vue";
import HeaderNotifications from "@/components/HeaderNotifications.vue";

@Component({
  components: {
    EnvCompanySelect,
    LocaleSwitcher,
    HeaderNotifications,
  },
})
export default class HeaderComponent extends Vue {

  @Getter private currentUser: any;
  @Getter private isAdmin: boolean;
  @Getter private mylobyEnv: string;

  public logout() {
    this.$store.dispatch("auth/logout");
  }
}
